var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHrr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 8.44922L11.5845 14.2283L8.06681 10.2744H1.89453C4.83723 15.6129 12.0945 19.2492 12.0945 19.2492C12.0945 19.2492 19.3531 15.6129 22.2945 10.2744H16.1745L14.9403 8.44922Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6116 0.0493164C16.4085 0.0497968 15.2345 0.364951 14.2481 0.952248C13.2617 1.53955 12.5103 2.37072 12.0953 3.3336C11.6184 2.2292 10.701 1.30303 9.50386 0.717223C8.30671 0.131411 6.90604 -0.076715 5.54705 0.129279C4.18806 0.335274 2.95734 0.942262 2.07035 1.84399C1.18336 2.74571 0.69661 3.88471 0.695312 5.0616C0.701012 6.0896 0.903381 7.10992 1.29445 8.08236H8.82351L11.315 10.8493L14.8338 4.85964L17.0454 8.08128H22.8974C23.2874 7.11049 23.4893 6.09205 23.4953 5.06592C23.4953 3.73543 22.8754 2.45944 21.772 1.51864C20.6686 0.57785 19.1721 0.0493164 17.6116 0.0493164V0.0493164Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5098 17.8492L21.5498 16.1812H21.0278V17.8492H20.3438V13.6792H21.7838C22.1037 13.6792 22.3737 13.7352 22.5938 13.8472C22.8178 13.9592 22.9838 14.1092 23.0918 14.2972C23.2038 14.4852 23.2598 14.6952 23.2598 14.9272C23.2598 15.1992 23.1798 15.4472 23.0198 15.6712C22.8638 15.8912 22.6218 16.0412 22.2938 16.1212L23.3258 17.8492H22.5098ZM21.0278 15.6352H21.7838C22.0397 15.6352 22.2318 15.5712 22.3598 15.4432C22.4918 15.3152 22.5578 15.1432 22.5578 14.9272C22.5578 14.7112 22.4938 14.5432 22.3658 14.4232C22.2378 14.2992 22.0438 14.2372 21.7838 14.2372H21.0278V15.6352Z",
    fill: "#313131"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrr);
export default __webpack_public_path__ + "static/media/hrr.841a51be0f95c1d069e3fe4a31041406.svg";
export { ForwardRef as ReactComponent };